import { render, staticRenderFns } from "./wonderful.vue?vue&type=template&id=7577d4a2&"
import script from "./wonderful.vue?vue&type=script&lang=js&"
export * from "./wonderful.vue?vue&type=script&lang=js&"
import style0 from "./wonderful.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports